// extracted by mini-css-extract-plugin
export default {"wrapper":"kHEriUINbLPMit3AfErz","breadcrumb":"UZFBKuIrkAj7F3PwyVCa","actions":"YKFCdjBQBIUTHO4OKJuK"};